// Tabs ==================================================
document.addEventListener('DOMContentLoaded', function () {
  const tabTitles = document.querySelectorAll('.tabs_title_d1');
  const tabContents = document.querySelectorAll('.content_d1');
  tabTitles.forEach(title => {
    title.addEventListener('click', function () {
      const clickedTitle = this.dataset.tabTitle.trim();
      tabTitles.forEach(t => t.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      tabContents.forEach(c => {
        if (c.dataset.tabTitle.trim() === clickedTitle) {
          c.classList.add('active');
        }
      });
    });
  });
});

// Before & After ==================================================
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.before_after_wrapper_d1');
  sliders.forEach(container => {
    const beforeImg = container.querySelector('.before_image_d1');
    const afterImg = container.querySelector('.after_image_d1');
    const slider = container.querySelector('.slider_handle_d1');
    const rangeInput = container.querySelector('.before_after_range_d1');
    let isDragging = false;
    const moveSlider = (percent) => {
      percent = Math.max(0, Math.min(100, percent));
      beforeImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      afterImg.style.clipPath = `inset(0 0 0 ${percent}%)`;
      slider.style.left = percent + '%';
      rangeInput.value = percent;
    };
    // Mouse dragging
    slider.addEventListener('mousedown', () => isDragging = true);
    document.addEventListener('mouseup', () => isDragging = false);
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const rect = container.getBoundingClientRect();
      const percent = ((e.clientX - rect.left) / rect.width) * 100;
      moveSlider(percent);
    });
    // Touch dragging
    slider.addEventListener('touchstart', () => isDragging = true);
    document.addEventListener('touchend', () => isDragging = false);
    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const rect = container.getBoundingClientRect();
      const percent = ((e.touches[0].clientX - rect.left) / rect.width) * 100;
      moveSlider(percent);
    });
    // Range input for mobile
    rangeInput.addEventListener('input', (e) => {
      moveSlider(e.target.value);
    });
    // Initialize in the center
    moveSlider(50);
  });
});

// Add to cart ==================================================
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function(e){
    const button = e.target.closest(".product_button_d1");
    if(!button) return;
    const variantId = button.dataset.variantId;
    if(!variantId) return;
    button.disabled = true;
    button.innerText = "ADDING...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(() => {
      // Redirect to cart page after adding
      window.location.href = "/cart";
    })
    .catch(err => {
      console.error("Cart error:", err);
      button.disabled = false;
      button.innerText = "ERROR, TRY AGAIN";
    });
  });
});
